import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeRouter from './landing-page/home'
import CareerRouter from './landing-page/career'
import NewsRouter from './landing-page/news'
import AboutUsRouter from './landing-page/about-us'
import ContactRouter from './landing-page/contact'
import OurBussinessRouter from './landing-page/our-bussiness'
import UserRouter from './landing-page/user-management'
import CommentRouter from './landing-page/comment-management'

Vue.use(VueRouter)

let routes = [
	// Landing Page
	{
		// will match everything
		path: '*',
		component: () => import('../views/404.vue'),
	},
	{
		path: '/',
		name: 'Home',
		redirect: '/home-banner',
	},
	...HomeRouter,
	...CareerRouter,
	...OurBussinessRouter,
	...NewsRouter,
	...AboutUsRouter,
	...ContactRouter,
	...UserRouter,
	...CommentRouter,
	{
		path: '/customer-review',
		name: 'CustomerReview',
		layout: "dashboard",
		component: () => import('../views/LandingPage/CustomerReview/index.vue'),
		meta: {
			openSidebarKey: 'customer-review',
			title: 'Quản lý review'
		}
	},
	{
		path: '/review/create',
		name: 'CreateReview',
		layout: "dashboard",
		component: () => import('../views/LandingPage/CustomerReview/Controller.vue'),
		meta: {
			openSidebarKey: 'customer-review',
			title: 'Thêm mới review'
		}
	},
	{
		path: '/review/:id',
		name: 'UpdateReview',
		layout: "dashboard",
		component: () => import('../views/LandingPage/CustomerReview/Controller.vue'),
		meta: {
			openSidebarKey: 'customer-review',
			title: 'Cập nhật review'
		}
	},
	{
		path: '/user-request-consultation',
		name: 'UserRequestConsultation',
		layout: "dashboard",
		component: () => import('../views/LandingPage/UserRequestConsultation/index.vue'),
		meta: {
			openSidebarKey: 'user-request-consultation',
			title: 'Quản lý danh sách đăng ký dùng thử '
		}
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('../views/LandingPage/Login/index.vue'),
	}
	// Blog
]

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute(route, parentLayout = "default") {
	route.meta = route.meta || {};
	route.meta.layout = route.layout || parentLayout;

	if (route.children) {
		route.children = route.children.map((childRoute) => addLayoutToRoute(childRoute, route.meta.layout));
	}
	return route;
}

routes = routes.map((route) => addLayoutToRoute(route));

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			}
		}
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	}
})

export default router
